import React from 'react';
import { Row, Col } from 'antd';
import { GetBest, Invest, Trade, Earn } from '../../assets/icons';
import './MarketCard.scss';

const MarketCard = () => {
  return (
    <div className='marketcard-wrapper'>
      <div className='container-fluid'>
        <Row gutter={[16, 16]}>
          <Col className='marketcard' sm={12} md={6}>
            <div className='marketcard__block'>
              <GetBest color='#8A4743' />
              <h4>Get the best</h4>
              <p>We handpick prime real estate investment opportunities on the market.
              </p>
            </div>
          </Col>
          <Col className='marketcard' sm={12} md={6}>
            <div className='marketcard__block'>
              <Invest color='#8A4743' />
              <h4>Invest</h4>
              <p>The initial sale period for our new properties last for 90 days or shorter, offered on a first-come, first-served basis.</p>
            </div>
          </Col>
          <Col className='marketcard' sm={12} md={6}>
            <div className='marketcard__block'>
              <Trade color='#8A4743' />
              <h4>Trade</h4>
              <p>Enhance your financial flexibility by effortlessly trading your shares in our dynamic market.</p>
            </div>
          </Col>
          <Col className='marketcard' sm={12} md={6}>
            <div className='marketcard__block'>
              <Earn color='#8A4743' />
              <h4>Earn</h4>
              <div>
                <p>The properties you own can generate dividends, driven by rental income and market performance.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className='marketcard__gradient'></div>
    </div>
  );
};

export default MarketCard;
